
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next",
      function () {
        return require("private-next-pages/next/index.tsx");
      }
    ]);
  